import { KeyboardEventHandler, useState, useRef, ChangeEvent } from 'react'
import { kuiperClassNames } from '@opallabs/kuiper'
import { PollNumber, PollNumberFuncs } from '..'
import { pollStyles, pollTextStyles } from './styles'

export interface Props {
  poll: string
  readOnly: boolean
  updatePoll: (updatedPoll: string) => void
  updatePollNumber: PollNumberFuncs
  pollPositions: { current: PollNumber; total: PollNumber }
}

export const Poll: React.FC<Props> = ({
  poll,
  updatePollNumber,
  readOnly,
  updatePoll,
  pollPositions,
}) => {
  const [pollText, setPollText] = useState(poll)
  const [focused, setFocus] = useState(false)
  const pollRef = useRef(null)
  const handleBlur = () => {
    setFocus(false)
    updatePoll(pollText)
  }

  const handleKeyPress: KeyboardEventHandler = (e) => {
    if (e.key === 'Backspace') {
      if (pollText === '') {
        e.preventDefault()
        updatePollNumber.decrement(pollPositions.current)
        setFocus(false)
      }
    } else if (e.key === 'Enter') {
      updatePollNumber.increment(pollPositions.current)
      setFocus(false)
      e.preventDefault()
    }
  }

  const validOption = Boolean(!focused && pollText?.length)
  const updateText = (e: ChangeEvent<HTMLInputElement>) => {
    if (e && e.currentTarget && typeof e.currentTarget?.value === 'string') {
      const text = e.currentTarget.value
      setPollText(text)
    }
  }

  /* eslint-disable jsx-a11y/no-static-element-interactions */
  return (
    <div
      onBlur={handleBlur}
      css={pollStyles}
      className={kuiperClassNames(
        `twitter-poll-option option-${pollPositions.current}`
      )}
      onFocus={() => setFocus(true)}
      onKeyUp={handleKeyPress}
      ref={pollRef}
    >
      <input
        aria-label={`Content Poll Option ${
          (pollPositions.current || 0) + 1
        } Text`}
        css={() => pollTextStyles(validOption)}
        placeholder="Add Poll Option..."
        readOnly={readOnly}
        onChange={updateText}
        value={pollText}
        maxLength={25}
      />
    </div>
  )
  /* eslint-enable jsx-a11y/no-static-element-interactions */
}
